<div class="prods-serv-menu-screen">
  <div class="sidebar sidebar--wide">
    <app-producer-sidebar></app-producer-sidebar>
  </div>

  <main class="display-box">
    <div class="uk-container">
      <div class="top-buttons">
        <button class="btn-retour" (click)="goBack()">
          <span uk-icon="icon: arrow-left"></span>
          Retour
        </button>
        <button class="btn-deconnexion" (click)="logOutPros()">
          <span uk-icon="icon: sign-out"></span>
          Déconnexion
        </button>
      </div>

      <div class="entry-block">
        <div class="uk-width-1-1">
          <div class="fix-form">

            <!-- Loader shown while fetching -->
            <div *ngIf="loader" class="global-loader">
              <div class="loader-spinner" role="status" aria-hidden="true"></div>
              <div class="loader-text">Chargement...</div>
            </div>

            <!-- Filter form -->
            <form [formGroup]="searchForm" (ngSubmit)="onSearchSubmit()" class="filter-form">
              <div class="filter-row">
                <div class="filter-item">
                  <label>N° Sinistre :</label>
                  <input type="text" formControlName="claimNumber" placeholder="CLM-...">
                </div>
                <div class="filter-item">
                  <label>Survenance Du :</label>
                  <input type="date" formControlName="incidenceDateMin">
                </div>
                <div class="filter-item">
                  <label>Survenance Au :</label>
                  <input type="date" formControlName="incidenceDateMax">
                </div>
                <div class="filter-item">
                  <label>Déclaration Du :</label>
                  <input type="date" formControlName="notificationDateMin">
                </div>
                <div class="filter-item">
                  <label>Déclaration Au :</label>
                  <input type="date" formControlName="notificationDateMax">
                </div>
                <div class="filter-item">
                  <label>Banque :</label>
                  <select formControlName="bankId" (change)="onBankSelected($event.target.value)">
                    <option [ngValue]="null">Toutes</option>
                    <option *ngFor="let b of userBanks" [value]="b.id">{{ b.name }}</option>
                  </select>
                  <div *ngIf="isLoadingBanks" class="small">Chargement banques...</div>
                </div>
                <div class="filter-item">
                  <label>Agence :</label>
                  <select formControlName="agencyId">
                    <option [ngValue]="null">Toutes</option>
                    <option *ngFor="let a of userAgencies" [value]="a.id">{{ a.name }}</option>
                  </select>
                  <div *ngIf="isLoadingAgencies" class="small">Chargement agences...</div>
                </div>
                <div class="filter-actions">
                  <button type="submit" class="uk-button " style="background-color:rgb(45 60 127 / 0.95) ; color:white;">Filtrer</button>
                </div>
              </div>
            </form>

            <!-- Tabs (moved under the filter) -->
            <div class="tabs-actions">
              <button type="button" class="tab-btn" [class.active]="activeView === 'toTransfer'"
                (click)="switchView('toTransfer')">
                <span uk-icon="icon: list"></span>
                Sinistres à transférer
                <span class="tab-count">({{ claimsToTransfer?.length || 0 }})</span>
              </button>

              <button type="button" class="tab-btn tab-draft" [class.active]="activeView === 'history'"
                (click)="switchView('history')">
                <span uk-icon="icon: history"></span>
                Historique des transferts
                <span class="tab-count">({{ transferHistory?.length || 0 }})</span>
              </button>
            </div>

            <!-- To Transfer view -->
            <div *ngIf="activeView === 'toTransfer'">
              <div class="table-responsive">
                <table *ngIf="!loader" style="width:100%">
                  <thead>
                    <tr>
                      <th class="sortable" (click)="onSort('claimNumber')">N° Sinistre <span
                          *ngIf="sortColumn === 'claimNumber'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span></th>
                      <th class="sortable" (click)="onSort('incidenceDate')">Date Surv. <span
                          *ngIf="sortColumn === 'incidenceDate'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span></th>
                      <th class="sortable" (click)="onSort('notificationDate')">Date Décla. <span
                          *ngIf="sortColumn === 'notificationDate'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                      </th>
                      <th class="sortable" (click)="onSort('effectiveDate')">Date Effet <span
                          *ngIf="sortColumn === 'effectiveDate'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span></th>
                      <th class="sortable" (click)="onSort('expirationDate')">Date Expiration <span
                          *ngIf="sortColumn === 'expirationDate'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span></th>
                      <th class="sortable" (click)="onSort('contratManualNumber')">N° Contrat Manuel <span
                          *ngIf="sortColumn === 'contratManualNumber'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                      </th>
                      <th class="sortable" (click)="onSort('productName')">Produit <span
                          *ngIf="sortColumn === 'productName'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span></th>
                      <th class="sortable" (click)="onSort('policyID')">ID Police <span
                          *ngIf="sortColumn === 'policyID'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span></th>
                      <th class="sortable" (click)="onSort('riskElement')">Élément Risque <span
                          *ngIf="sortColumn === 'riskElement'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span></th>
                      <th class="sortable" (click)="onSort('status')">Statut <span *ngIf="sortColumn === 'status'">{{
                          sortDirection === 'asc' ? '▲' : '▼' }}</span></th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngIf="!loader && claimsToTransfer.length === 0">
                      <td colspan="11" style="text-align:center;padding:20px;">Aucun sinistre à transférer</td>
                    </tr>
                    <tr *ngFor="let c of displayedClaims">
                      <td>{{ c?.claimNumber }}</td>
                      <td>{{ c?.incidenceDate | date:'dd/MM/yyyy' }}</td>
                      <td>{{ c?.notificationDate | date:'dd/MM/yyyy' }}</td>
                      <td>{{ c?.effectiveDate | date:'dd/MM/yyyy' }}</td>
                      <td>{{ c?.expirationDate | date:'dd/MM/yyyy' }}</td>
                      <td>{{ c?.contratManualNumber }}</td>
                      <td>{{ c?.productName }}</td>
                      <td>{{ c?.policyID }}</td>
                      <td>{{ c?.riskElement }}</td>
                      <td><span class="status-badge" [ngClass]="getStatusClass(c?.status)">{{ getStatusLabel(c?.status)
                          }}</span></td>
                      <td>
                        <ng-container *ngIf="transferProgressById[(c?.id + '')] === undefined; else inProgress">
                          <button class="uk-button uk-button-default" (click)="openClaimDetails(c)">Voir</button>
                          <button class="uk-button uk-button-primary" (click)="transferClaim(c)">Transférer</button>
                        </ng-container>
                        <ng-template #inProgress>
                          <div class="transfer-progress">
                            <div class="bar" aria-hidden>
                              <div class="fill" [style.width.%]="transferProgressById[(c?.id + '')] || 0"></div>
                            </div>
                            <div class="percent">{{ transferProgressById[(c?.id + '')] || 0 }}%</div>
                          </div>
                        </ng-template>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="pagination-controls" *ngIf="!loader && totalCount > 0">
                <div class="page-size-control"><label>Afficher :</label>
                  <select [value]="pageSize" (change)="onPageSizeChange($event)" class="uk-select">
                    <option [value]="5">5</option>
                    <option [value]="10">10</option>
                    <option [value]="25">25</option>
                    <option [value]="50">50</option>
                  </select>
                </div>
                <div class="pagination-info">Page {{ currentPage }} / {{ totalPages }} ({{ totalCount }} résultats)
                </div>
                <div class="pagination-buttons">
                  <button type="button" class="uk-button uk-button-default" (click)="goToPage(currentPage - 1)"
                    [disabled]="currentPage === 1">&lt;</button>
                  <ng-container *ngFor="let page of getPaginationNumbers()">
                    <button *ngIf="page !== '...'" type="button" class="uk-button"
                      [ngClass]="{'uk-button-primary': page === currentPage, 'uk-button-default': page !== currentPage}"
                      (click)="goToPage(page)">{{ page }}</button>
                    <span *ngIf="page === '...'" class="pagination-ellipsis">...</span>
                  </ng-container>
                  <button type="button" class="uk-button uk-button-default" (click)="goToPage(currentPage + 1)"
                    [disabled]="currentPage === totalPages">&gt;</button>
                </div>
              </div>
            </div>

            <!-- History view -->
            <div *ngIf="activeView === 'history'">
              <div class="table-responsive">
                <table style="width:100%">
                  <thead>
                    <tr>
                      <th class="sortable" (click)="onSort('claimNumber')">N° Sinistre <span
                          *ngIf="sortColumn === 'claimNumber'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span></th>
                      <th class="sortable" (click)="onSort('incidenceDate')">Date Surv. <span
                          *ngIf="sortColumn === 'incidenceDate'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span></th>
                      <th class="sortable" (click)="onSort('notificationDate')">Date Décla. <span
                          *ngIf="sortColumn === 'notificationDate'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                      </th>
                      <th class="sortable" (click)="onSort('effectiveDate')">Date Effet <span
                          *ngIf="sortColumn === 'effectiveDate'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span></th>
                      <th class="sortable" (click)="onSort('expirationDate')">Date Expiration <span
                          *ngIf="sortColumn === 'expirationDate'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span></th>
                      <th class="sortable" (click)="onSort('contratManualNumber')">N° Contrat Manuel <span
                          *ngIf="sortColumn === 'contratManualNumber'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span>
                      </th>
                      <th class="sortable" (click)="onSort('productName')">Produit <span
                          *ngIf="sortColumn === 'productName'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span></th>
                      <th class="sortable" (click)="onSort('policyID')">ID Police <span
                          *ngIf="sortColumn === 'policyID'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span></th>
                      <th class="sortable" (click)="onSort('riskElement')">Élément Risque <span
                          *ngIf="sortColumn === 'riskElement'">{{ sortDirection === 'asc' ? '▲' : '▼' }}</span></th>
                      <th class="sortable" (click)="onSort('status')">Statut <span *ngIf="sortColumn === 'status'">{{
                          sortDirection === 'asc' ? '▲' : '▼' }}</span></th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngFor="let c of displayedHistory">
                      <td>{{ c?.claimNumber }}</td>
                      <td>{{ c?.incidenceDate | date:'dd/MM/yyyy' }}</td>
                      <td>{{ c?.notificationDate | date:'dd/MM/yyyy' }}</td>
                      <td>{{ c?.effectiveDate | date:'dd/MM/yyyy' }}</td>
                      <td>{{ c?.expirationDate | date:'dd/MM/yyyy' }}</td>
                      <td>{{ c?.contratManualNumber }}</td>
                      <td>{{ c?.productName }}</td>
                      <td>{{ c?.policyID }}</td>
                      <td>{{ c?.riskElement }}</td>
                      <td><span class="status-badge" [ngClass]="getStatusClass(c?.status)">{{ getStatusLabel(c?.status)
                          }}</span></td>
                      <td><button class="uk-button uk-button-default" (click)="openClaimDetails(c)">Voir</button></td>
                    </tr>
                  </tbody>
                </table>
              </div>

              <div class="pagination-controls" *ngIf="!loader && transferHistory.length > 0">
                <div class="page-size-control"><label>Afficher :</label>
                  <select [value]="pageSize" (change)="onPageSizeChange($event)" class="uk-select">
                    <option [value]="5">5</option>
                    <option [value]="10">10</option>
                    <option [value]="25">25</option>
                    <option [value]="50">50</option>
                  </select>
                </div>
                <div class="pagination-info">Page {{ currentPage }} / {{ totalPages }} ({{ transferHistory.length }}
                  résultats)</div>
                <div class="pagination-buttons">
                  <button type="button" class="uk-button uk-button-default" (click)="goToPage(currentPage - 1)"
                    [disabled]="currentPage === 1">&lt;</button>
                  <ng-container *ngFor="let page of getPaginationNumbers()">
                    <button *ngIf="page !== '...'" type="button" class="uk-button"
                      [ngClass]="{'uk-button-primary': page === currentPage, 'uk-button-default': page !== currentPage}"
                      (click)="goToPage(page)">{{ page }}</button>
                    <span *ngIf="page === '...'" class="pagination-ellipsis">...</span>
                  </ng-container>
                  <button type="button" class="uk-button uk-button-default" (click)="goToPage(currentPage + 1)"
                    [disabled]="currentPage === totalPages">&gt;</button>
                </div>
              </div>
            </div>

          </div> <!-- .fix-form -->
        </div> <!-- .uk-width-1-1 -->
      </div> <!-- .entry-block -->

    </div> <!-- .uk-container -->
  </main>
</div>
